/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const GetFeeInputJsonApiModel = {
  id: "",
  filters: {
    jsonApi: "hasOne",
    type: "fee-filters",
  },
};
